const isTest = false;
const apiProtocol = 'https://';
const baseUrl = isTest?'test.aiverse.cn':'api.aiverse.cn';
const H5BaseUrl = isTest?'test.bestcovered.com':'cps.bestcovered.com'
const btOldAssetsUrl = 'https://cdn.bestcovered.com/alipay-asset/bt-old/';
const cpsAssetsUrl = 'https://cdn.bestcovered.com/bestcovered-cps/';
const bestcoveredAssetsUrl = 'https://cdn.bestcovered.com/bestcovered/';
const obsUrl = "https://live-hw.bestcovered.com/cps/"
let apiUrl = apiProtocol + baseUrl;
let H5ApiUrl = 'https://' + H5BaseUrl
export default {
    service: {
		versionNumber: '1.0.1',
        cpsAssetsUrl,
        bstLdUrl: isTest ? 'https://cps-test.bestcovered.com/bst-ld':'https://cps.bestcovered.com/bst-ld',
        btOldAssetsUrl,
        baseAssetsUrl: btOldAssetsUrl,
        bestcoveredAssetsUrl,
		machineAssetsUrl: 'https://cdn.bestcovered.com/bestcovered/scs-component/',
		obsUrl,
        apiUrl,
        H5ApiUrl,
        H5BaseUrl,
        planId:202101,
        trainUrl:`${apiUrl}/train`,
        surveyUrl:`${apiUrl}/survey-v2`,
		// surveyUrl:`http://172.16.90.43:8098/survey-v2`,
        orderUrl:`${apiUrl}/order`,
		// orderUrl:`http://localhost:8099/order`,
        taskTrainUrl: 'https://cdn.bestcovered.com/bt/base/v1/index.html?isH5=1',
        g3Url: isTest?'https://cdn.bestcovered.com/g3/base/v1-test/index.html?isH5=1':'https://cdn.bestcovered.com/g3/base/event-tracking/index.html?isH5=1',
        g3UrlWithFace: isTest?'https://cdn.bestcovered.com/g3/base/face/v1-test/index.html?isH5=1':'https://cdn.bestcovered.com/g3/base/face/v1/index.html?isH5=1',
		landingH5DiversionUrl: isTest?'https://cps-test.bestcovered.com/bst-ld/diversion/index':'https://cps.bestcovered.com/bst-ld/diversion/index',
        isTest,
        scsUrl: isTest ? 'https://cps-test.bestcovered.com/scs/pages/index/index' : 'https://cps.bestcovered.com/scs/pages/index/index',
    }
};

